export default {
	"userOrganization": {
		"tipsUnbind": "remove",
		"allStatus": "all status",
		"userName": "Name",
		"mobile": "Cell Phone",
		"selectRole": "please select a role",
		"selectDepartment": "please select a department",
		"selectBusinessUnit": "Select Business Unit",
		"selectAllBusinessUnit": "Select all Business Unit",
		"noSubordinate": "no subordinates",
		"noMatchDepartment": "no matching department",
		"isDisabled": "disabled",
		"department": "department",
		"onlyCurrentOrganization": "only see current organization personnel",
		"organization": "organization",
		"organizationName": "name of the organization",
		"role": "role",
		"roleName": "role name",
		"addNewRole": "add new role",
		"addUser": "Add People",
		"employeeNumber": "Staff Code",
		"userGender": "Gender",
		"userPosition": "Position",
		"userEmail": "Email",
		"telephone": "landline",
		"userWechat": "wechat",
		"userModify": "Personnel modification",
		"modifyAvatar": "modify avatar",
		"credentialNo": "license number",
		"addOrganization": "add an organization",
		"confirmRemoveRole": "are you sure to remove the current user role?",
		"createUserSuccess": "Create user successfully",
		"editUserSuccess": "Edit user successfully",
		"removeUserSuccess": "Remove user successfully",
		"enableUserSuccess": "Enable user successfully",
		"disableUserSuccess": "Disable user successfully"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/userOrganization/userOrganization.js